import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">品牌故事</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">了解古古漫画网的故事与使命</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70 mb-8">
            <h3 className="font-heading font-bold text-lg text-foreground-900 mb-4">{aboutInfo.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{aboutInfo.desc}</p>
            <p className="text-sm text-foreground-600 leading-relaxed">{aboutInfo.desc2}</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutInfo.stats.map((stat, i) => (
              <div key={i} className="text-center p-4 rounded-lg bg-background-100 border border-background-200/70">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">{stat.value}</div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}